import { Action } from '../../infra/types'
import { SeedAction } from './seed.action'
import { SeedState } from './seed.state'
import { ISeedState, ISeedBusinessState } from './seed.types'

const upsert = (
  state: ISeedState,
  businessId: string,
  patch: Partial<ISeedBusinessState>
): ISeedState => {
  const existing: ISeedBusinessState = state.byBusinessId[businessId] || {
    status: 'idle',
    isActive: false,
    phase: 'started'
  }
  return {
    ...state,
    byBusinessId: {
      ...state.byBusinessId,
      [businessId]: { ...existing, ...patch }
    }
  }
}

export const SeedReducer = (state: ISeedState = SeedState, action: Action<any>): ISeedState => {
  switch (action.type) {
    case SeedAction.SEED_STARTED: {
      const { businessId, isActive } = action.payload
      const next = upsert(state, businessId, {
        status: 'seeding',
        isActive,
        phase: 'started',
        entryCount: undefined,
        error: undefined
      })
      return { ...next, activeBusinessId: isActive ? businessId : next.activeBusinessId }
    }
    case SeedAction.SEED_PHASE: {
      const { businessId, phase, entryCount } = action.payload
      return upsert(state, businessId, entryCount === undefined ? { phase } : { phase, entryCount })
    }
    case SeedAction.SEED_SUCCESS: {
      const { businessId } = action.payload
      const next = upsert(state, businessId, { status: 'done', error: undefined })
      return {
        ...next,
        activeBusinessId: state.activeBusinessId === businessId ? null : state.activeBusinessId
      }
    }
    case SeedAction.SEED_FAILURE: {
      const { businessId, error } = action.payload
      // Keep activeBusinessId so the blocking "Sync Failed" screen (with Retry)
      // stays up for the active business, matching Android.
      return upsert(state, businessId, { status: 'failed', error })
    }
    case SeedAction.SKIP_SEED: {
      const { businessId } = action.payload
      const next = upsert(state, businessId, { status: 'skipped' })
      return {
        ...next,
        activeBusinessId: state.activeBusinessId === businessId ? null : state.activeBusinessId
      }
    }
    case SeedAction.RESET_SEED_STATE: {
      return SeedState
    }
    default: {
      return state
    }
  }
}
